import axios from "axios";
import { useEffect, useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Pagination from 'react-bootstrap/Pagination';
import moment from 'moment'
import { Spinner, Table } from "react-bootstrap";
import currency from "currency.js";
import InputMask from 'react-input-mask';
import './style.scss';

const Transactions = () => {
  const [transactions, setTransactions] = useState([])
  const [busy, setBusy] = useState(false)
  const [date, setDate] = useState(moment().format('DD/MM/YYYY'))
  const [isDate, setIsDate] = useState(true)
  const [su, setSu] = useState('')
  const [pu, setPu] = useState('')

  const [page, setPage] = useState(1)
  const [pages, setPages] = useState([])
  const [total, setTotal] = useState(0)
  const perPage = 25

  const getTransactions = () => {
    setBusy(true)
    axios.get('/api/administration/transactions', {
      params: {
        page,
        per_page: perPage,
        date,
        isDate,
        su,
        pu
      }
    })
      .then(response => {
        setTransactions(response.data.data)
        setTotal(response.data.total)
      })
      .catch(error => {})
      .finally(() => {
        setBusy(false)
      })
  }

  useEffect(() => {
    getTransactions()
  }, [page])

  useEffect(() => {
    if (isDate) {
      setDate(moment().format('DD/MM/YYYY'))
    } else {
      setDate('')
    }
  }, [isDate])

  useEffect(() => {
    let tmpPages = [];
    const numPages = Math.ceil(total/perPage)
    for(let i=0; i<numPages; i++) {
      tmpPages.push(
        <Pagination.Item
          key={i}
          active={page === (i+1)}
          onClick={() => setPage(i+1)}
        >
          {i+1}
        </Pagination.Item>
      )
    }

    setPages(tmpPages)
  }, [page, total])

  const handleSubmit = (e) => {
    e.preventDefault()
    getTransactions()
  }

  const clearSuSearchText = () => {
    setSu('');
  }

  const clearPuSearchText = () => {
    setPu('');
  }

  return (
    <div className="subscriber-transactions">
      <h3 className="mb-4">User Transactions</h3>

      <Form inline onSubmit={handleSubmit}>
        <div className="row col-md-8">
          <div className="w-10 pl-3 col-md-1">
            <Form.Check
              type="checkbox"
              className="my-1 mr-sm-2"
              id="date"
              label="Day"
              custom
              checked={isDate}
              onChange={(e) => setIsDate(! isDate)}
            />
          </div>
          <div className="col-md-2">
            <Form.Group>
                <InputMask
                  mask="99/99/9999"
                  className="mx-sm-3"
                  id="date"
                  aria-describedby="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  disabled={!isDate}
                  size="sm"
                  placeholder="DD/MM/YYYY"
                />
              </Form.Group>
              {/* <Form.Check
                type="checkbox"
                className="my-1 mr-sm-2"
                id="isSu"
                label="SU"
                custom
              /> */}
          </div>
          <div className="col-md-3">
            <Form.Group style={{ flexFlow: 'nowrap' }}>
              <Form.Label>SU</Form.Label>
              <Form.Control
                type="text"
                className="mx-sm-3"
                id="su"
                aria-describedby="su"
                size="sm"
                value={su}
                onChange={(e) => setSu(e.target.value)}
              />
              {
                su && <i className="fal fa-times search-clear-icon" onClick={clearSuSearchText} />
              }
            </Form.Group>
            {/* <Form.Check
              type="checkbox"
              className="my-1 mr-sm-2"
              id="isPu"
              label="PU"
              custom
            /> */}
          </div>
          <div className="col-md-3">
            <Form.Group style={{ flexFlow: 'nowrap' }}>
              <Form.Label>PU</Form.Label>
              <Form.Control
                type="text"
                className="mx-sm-3"
                id="pu"
                aria-describedby="pu"
                size="sm"
                value={pu}
                onChange={(e) => setPu(e.target.value)}
              />
              {
                pu && <i className="fal fa-times search-clear-icon" onClick={clearPuSearchText} />
              }
            </Form.Group>
          </div>
          <div className="col-md-2">
          <Button type="submit" disabled={busy}>
            Search
          </Button>
          </div>
        </div>
      </Form>

      <div className="mt-2">
        <div className="my-2">
          <Pagination size="sm" style={{justifyContent: 'flex-end'}}>{pages}</Pagination>
        </div>
        <Table size="sm" striped hover>
          <thead>
            <tr>
              <th className="border-top-0">Date Time</th>
              <th className="border-top-0" style={{textAlign: 'right'}}>Amount Paid</th>
              <th className="border-top-0">SU Username</th>
              <th className="border-top-0">Type</th>
              <th className="border-top-0" style={{textAlign: 'right'}}>Pay to PU</th>
              <th className="border-top-0">PU Username</th>
              <th className="border-top-0" style={{textAlign: 'right'}}>Pay to RU</th>
              <th className="border-top-0">RU Username</th>
              <th className="border-top-0" style={{textAlign: 'right'}}>Pay to RU2</th>
              <th className="border-top-0">RU2 Username</th>
              <th className="border-top-0" style={{textAlign: 'right'}}>To Admin</th>
              <th className="border-top-0">SU Sign Up Date</th>
            </tr>
          </thead>

          <tbody>
            {
              transactions.length > 0 
                ? transactions.map((transaction) => {
                    return <tr key={transaction.id}>
                        <td>
                          {moment.utc(transaction.created_date).local().format('LLL')}
                        </td>
                        <td style={{textAlign: 'right'}}>
                          { currency(transaction.su_total).format() }
                        </td>
                        <td>
                          {transaction.su_username || '-'}
                        </td>
                        <td>
                          {transaction.transaction_type}
                        </td>
                        <td style={{textAlign: 'right'}}>
                          {currency(transaction.pu_total).format()}
                        </td>
                        <td>
                          {transaction.pu_username || '-'}
                        </td>
                        <td style={{textAlign: 'right'}}>
                          {currency(transaction.ru_total).format()}
                        </td>
                        <td>
                          {transaction.ru_username || '-'}
                        </td>
                        <td style={{textAlign: 'right'}}>
                          {currency(transaction.ru2_total).format()}
                        </td>
                        <td>
                          {transaction.ru2_username || '-'}
                        </td>
                        <td style={{textAlign: 'right'}}>
                          {currency(transaction.admin_total).format()}
                        </td>
                        <td>
                          {moment.utc(transaction.registered).local().format('LLL')}
                        </td>
                      </tr>
                })
              : <tr>
                <td colSpan="12">
                  {
                    busy ? <Spinner variant="primary" animation="border" size="sm" /> : 'No data found'
                  }
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr>
              <th>Date Time</th>
              <th>Amount Paid  </th>
              <th>SU Username</th>
              <th>Type</th>
              <th>Pay to PU</th>
              <th>PU Username</th>
              <th>Pay to RU</th>
              <th>RU Username</th>
              <th>Pay to RU2</th>
              <th>RU2 Username</th>
              <th>To Admin</th>
              <th>SU Sign Up Date</th>
            </tr>
          </tfoot>
        </Table>
        <div className="my-2">
          <Pagination size="sm" style={{justifyContent: 'flex-end'}}>{pages}</Pagination>
        </div>
      </div>
    </div>
  )
}

export default Transactions;